var _ = require('underscore');
var TorsoCollection = require('backbone-torso/modules/Collection');
var PaymentProcessingDeviceModel = require('./PaymentProcessingDeviceModel');
var paymentProcessingDeviceExtService = require('./../../urls').paymentProcessingDeviceExtService;

/**
 * Model representing a collection of payment devices.
 * @class paymentProcessingDeviceCollection
 * @extends Torso.Collection
 */
module.exports = new (TorsoCollection.extend({
  model: PaymentProcessingDeviceModel,
  url: paymentProcessingDeviceExtService,
  fetchHttpAction: 'POST',

  /**
   * Only makes sense for private collections.  Nobody cares (or shouldn't) how the cache is ordered.
   * @method comparator
   * @param model {Backbone.Model} the model to index for this collection.
   * @returns {Number} a unique index that can be used to sort this model.
   *          Represents the index of this model's id in the tracked ids of this private collection.
   */
  comparator: function(model) {
    if (!this.trackedIds) {
      return undefined;
    }
    return _.indexOf(this.trackedIds, model.get(model.idAttribute));
  },

  /**
   * Fetch a list of Device Ids by criteria
   * @method fetchIdsByCriteria
   * @param criteria {String} criteria suitable for the paymentProcessingDeviceExtService
   * @return A Promise wrapping a list of ids
   */
  fetchIdsByCriteria : function(criteria) {
    return $.ajax({
      url: paymentProcessingDeviceExtService + '/criteria',
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(criteria)
    });
  }
}))();
